import { render, staticRenderFns } from "./gamelist.vue?vue&type=template&id=309376e9&scoped=true"
import script from "./gamelist.vue?vue&type=script&lang=js"
export * from "./gamelist.vue?vue&type=script&lang=js"
import style0 from "./gamelist.vue?vue&type=style&index=0&id=309376e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309376e9",
  null
  
)

export default component.exports